import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import { CiClock2 } from "react-icons/ci";
import ExamTimeCal from "./ExamTimeCal";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// Below is for import the components
import "../Assests/Scss/Answersheet.scss";
import ReviewSubmit from "./ReviewSubmit";
import CopyRight from "../Reusablecomponents/Copyright";
import ScenarioQuestionformat from "../Reusablecomponents/ScenarioQuestionformat";
import Loading from "../Reusablecomponents/Loading";
import InternetChecking from "../Reusablecomponents/Network";
import CNFSubmit from "../Assessment/CNFSubmit";
import { FaCaretRight, FaCaretLeft } from "react-icons/fa";
import { MdOutlineSpeakerNotes } from "react-icons/md";
import { ANameData } from "../../Redux/Reducers/Common/AssessmentName";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";
import { useTranslation } from "react-i18next";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { UnitsDD } from "../../ReusableComponents/QBDropdowns";
const Ansewersheet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const SUBJectRef = useRef();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));
  const Subjects = JSON.parse(localStorage.getItem("SUbjectData"))["Subjects"];
  const [CompleteSubjects, SetCompleteSubjects] = useState([Subjects[0]]);
  const [OpenModel, CLoseModel] = useState(false);
  // Below usestate is for Answer sheet
  const [ExamApi, setExamApi] = useState(AssessmentData?.subject1Name);
  const [SubjectData, setSubjectData] = useState();
  const [QNo, setQNo] = useState(0);
  const [visitedQuestions, setVisitedQuestions] = useState([]);
  const [UserSelectedAnswers, setUserSelectedAnswers] = useState([]);
  // Below usestates is for time calculation
  const [SubDuration, setSubDuration] = useState(AssessmentData.sub1Duration);
  const [PresentExam, setPresentExam] = useState();
  const [GeTime, setGeTime] = useState();
  const [CNFModel, SetCNFModel] = useState(false);
  const [CNFsubmit, SetCNFsubmit] = useState(false);
  const [STModel, SetSTModel] = useState(false);
  const [Load, SetLoad] = useState(false);
  const [MAnswers, SetMAnswers] = useState([]);

  const [EditQuestion, SetEditQuestion] = useState(false);
  const [Units, SetUnits] = useState();
  const SubmitExam = () => {
    if (
      navigator.onLine &&
      Object.keys(UserSelectedAnswers).length > 0 &&
      GeTime < ExamHoldtime()
    ) {
      CLoseModel(!OpenModel);
    }
  };

  const requestFullScreen = async () => {
    try {
      await document.documentElement.requestFullscreen();
    } catch (err) {
      console.error(
        `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
      );
    }
  };

  const ExitFullScreen = () => {
    if (
      !document.fullscreenElement &&
      location?.pathname !== "/Student/Results"
    ) {
      navigate("/Student/Assessment", { replace: true });
    }
  };

  // Below function is to get the question papper
  const fetchSTUDENTASSESSMENTQPAPER = async (ExamName) => {
    const subjectURL =
      process.env.REACT_APP_API_BASE_URL +
      `/ASSESSMENT/GETSTUDENTASSESSMENTQPAPER?CONTESTCREATIONID=${AssessmentData.contestCreationID}&USERID=${items.userId}&SUBJECT=${ExamName}&AssessmentType=${AssessmentData.assessmentType}&LanguageId=${items?.mediumId}`;
    await axios
      .get(subjectURL, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
      .then((res) => {
        if (res.data?.[QNo]?.subjectName) {
          dispatch(ANameData({ SName: res.data?.[QNo]?.subjectName }));
          setPresentExam(ExamName);
          setExamApi(ExamName);
          setSubjectData(res.data);
          SUBJectRef.current = res.data;
          setVisitedQuestions([...visitedQuestions, res.data[QNo].questionId]);
          if (localStorage.getItem("ResumeId") === "Resume") {
            res.data.forEach((element) => {
              if (element.studentAnswer !== "") {
                setUserSelectedAnswers((prevState) => ({
                  ...prevState,
                  [element.questionId]: element.studentAnswer,
                }));
              }
              if (element.isReviewed === 1) {
                setVisitedQuestions((prevState) => [
                  ...prevState,
                  element.questionId,
                ]);
              }
            });
          }
        } else {
          alert(
            "The Question Paper is not scheduled for this assessment. Please contact admin"
          );
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Below function is to get the subject name at the time of resume test
  const fetchSUBJECTINRESUMETEST = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Assessment/GETSUBJECTINRESUMETEST?ContestCreationId=${AssessmentData.contestCreationID}&UserID=${items.userId}&AssessmentType=${AssessmentData.assessmentType}&Grade=${items.grade}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (Subjects.findIndex((sub) => sub === res.data) >= 0) {
          fetchSTUDENTASSESSMENTQPAPER(res.data);
        } else {
          navigate("/Student/FeedBack", { replace: true });
        }
        if (Subjects.findIndex((sub) => sub === res.data) >= 1) {
          SetCompleteSubjects(Subjects.slice(0, Subjects.findIndex((sub) => sub === res.data) + 1));
        } else {
          SetCompleteSubjects([res.data]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const listener = () => {
    if (!document.hasFocus()) {
      ExitFullScreen();
      if (
        localStorage.getItem("timeupAlertShown") === null &&
        SUBJectRef.current?.length >= 2
      ) {
        alert(t("Answersheet.AssessmentWindowTabClose"));
      }
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    SetLoad((prev) => !prev);
    requestFullScreen();
    if (localStorage.getItem("ResumeId") === "Resume") {
      fetchSUBJECTINRESUMETEST();
    } else {
      fetchSTUDENTASSESSMENTQPAPER(ExamApi);
    }

    document.addEventListener("fullscreenchange", ExitFullScreen);
    window.addEventListener("focus", listener);
    window.addEventListener("blur", listener);
    return () => {
      document.removeEventListener("fullscreenchange", ExitFullScreen);
      window.removeEventListener("focus", listener);
      window.removeEventListener("blur", listener);
    };
  }, [ExamApi]);

  // Below function is to Submit the each session ,OpenModel
  const EachTestSubmit = async (SubName) => {
    const SECTIONSUBMITTEparam = {
      ContestCreationId: AssessmentData.contestCreationID,
      UserId: items.userId,
      SubjectName: SubName,
      AssessmentType: AssessmentData.assessmentType,
    };

    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL +
        "/ASSESSMENT/UPDATESECTIONSUBMITTED",
        SECTIONSUBMITTEparam,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => { })
      .catch((err) => {
        console.log(err);
      });
  };
  // Below function is to Submit finially
  const FinalSubmit = async () => {
    SetLoad((prev) => !prev);
    const AssessmentFinalSubmitparam = {
      ContestCreationId: AssessmentData.contestCreationID,
      UserId: items.userId,
      AssessmentType: AssessmentData.assessmentType,
      SubjectName:
        AssessmentData?.testType === "single"
          ? AssessmentData?.subject1Name
          : "",
    };

    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL +
        "/Assessment/AssessmentFinalSubmit",
        AssessmentFinalSubmitparam,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetLoad((prev) => !prev);
        navigate("/Student/FeedBack", { replace: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Below function is to Save answers and move to next exam
  const saveAnswers = () => {
    setSubjectData();
    localStorage.removeItem("ResumeId");
    CLoseModel(false);
    if (Subjects.length === CompleteSubjects.length) {
      EachTestSubmit(SubjectData[QNo].subjectName);
      FinalSubmit();
    } else {
      setPresentExam("");
      EachTestSubmit(SubjectData[QNo].subjectName);
      setSubDuration(
        AssessmentData.allSubjectDuration.split(",")[CompleteSubjects.length]
      );
      setExamApi(Subjects[CompleteSubjects.length]);
      SetCompleteSubjects([
        ...CompleteSubjects,
        Subjects[CompleteSubjects.length],
      ]);
    }
    setUserSelectedAnswers([]);
    setVisitedQuestions([]);
    setQNo(0);
    // }
  };

  // Below function is for visitted questions
  const seenQuestions = async (e) => {
    if (!visitedQuestions.includes(e)) {
      setVisitedQuestions([...visitedQuestions, e]);
    }
  };
  const handleAnswerChange = async (
    e,
    correctanswer,
    Studentanswer,
    Sunits
  ) => {
     SetLoad((prev) => !prev);
    const name = e?.target?.name || e;
    const UpdateStudentResponseparam = {
      ContestCreationId: AssessmentData.contestCreationID,
      UserId: items.userId,
      QuestionId: name,
      Answer: correctanswer,
      StudentAnswer:
        SubjectData?.[QNo]?.answerValType === "M"
          ? Studentanswer?.filter((str) => str !== "")?.join(",")
          : Studentanswer,
      AssessmentType: AssessmentData.assessmentType,
      AnswerValType: SubjectData?.[QNo]?.answerValType,
      AnswerType: SubjectData?.[QNo]?.answerType,
      UnitId: Sunits || Units || 0,
      ActualUnitId: SubjectData?.[QNo]?.actualUnitId,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL +
        "/Assessment/UpdateStudentResponse",
        UpdateStudentResponseparam,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      )
      .then((res) => {
        if (res.data === 1) {

          const name = e?.target?.name || e;
          // const { name, value } = e.target;
          if (
            name in UserSelectedAnswers &&
            UserSelectedAnswers[name] === Studentanswer &&
            SubjectData?.[QNo]?.questionType === "M"
          ) {
            delete UserSelectedAnswers[name];
            Studentanswer = "";
          } else {
            if (
              GeTime > ExamHoldtime() &&
              Object.keys(UserSelectedAnswers).length === SubjectData.length - 1
            ) {
              SetSTModel(true);
            }
            setUserSelectedAnswers({
              ...UserSelectedAnswers,
              [name]:
                SubjectData?.[QNo]?.answerValType === "M"
                  ? Studentanswer?.filter((str) => str !== "")?.join(",")
                  : SubjectData?.[QNo]?.answerType === "U"
                    ? [Studentanswer, Sunits || Units]
                    : Studentanswer,
            });
          }

          // notify("Your answer is saved successfully.", "success");
        } else if (res.data === 0) {
          notify("Answer is not saved. Please check the internet and try again.", "warning");
        }
         SetLoad((prev) => !prev);
        //  SetINQ(); SetMAnswers([])
      })
      .catch((err) => {
         SetLoad((prev) => !prev);
         notify("Answer is not saved. Please check the internet and try again.", "warning")});
  };

  const MAhandleChange = (index, e) => {
    const newInputs = [...MAnswers];
    switch (SubjectData?.[QNo]?.answerType) {
      case "T":
        const CONVERT = e.target.value
          .replace(/[^a-zA-Z0-9]/g, "")
          .slice(0, 30);
        newInputs[index] = CONVERT;
        break;
      case "F":
        const CONVER = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 3);
        newInputs[index] = CONVER;
        break;
      default:
        const Number = e.target.value.replace(/[^0-9.]/g, "").slice(0, 10);
        newInputs[index] = Number;
        break;
    }
    SetMAnswers(newInputs);
  };
  const BackgroundBG = () => {
    switch (SubjectData?.[QNo]?.subjectName) {
      case "English":
        return "EnglishBGAswersheet";
      case "Mathematics":
        return "MathsBGAswersheet";
      case "Biology":
        return "BiologyBGAswersheet";
      default:
        return "ScienceBGAswersheet";
    }
  };
  const [INQ, SetINQ] = useState();
  const SelecType = () => {
    switch (SubjectData?.[QNo]?.answerType) {
      case "T":
        return "text";
      case "F":
        return "text";
      default:
        return "number";
    }
  };
  const StoreINQAnswer = (e) => {
    switch (SubjectData?.[QNo]?.answerType) {
      case "T":
        const CONVERT = e.target.value
          .replace(/[^a-zA-Z0-9]/g, "")
          .slice(0, 30);
        SetINQ(CONVERT);
        break;
      case "F":
        const CONVER = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 3);
        SetINQ(CONVER);
        break;
      default:
        const Number = e.target.value.replace(/[^0-9.]/g, "").slice(0, 10);
        SetINQ(Number.trim());
        break;
    }
  };
  useMemo(() => {
    if (SubjectData?.[QNo]?.questionType === "D") {
      if (SubjectData?.[QNo]?.answerValType !== "M") {
        SetINQ(
          SubjectData?.[QNo]?.answerType === "U"
            ? UserSelectedAnswers?.[SubjectData?.[QNo]?.questionId]?.[0] || ""
            : UserSelectedAnswers?.[SubjectData?.[QNo]?.questionId] || ""
        );
        SetMAnswers([""]);
        if (SubjectData?.[QNo]?.actualUnitId > 0) {
          SetUnits(
            UserSelectedAnswers?.[SubjectData?.[QNo]?.questionId]?.[1] || ""
          );
        }
      } else {
        SetMAnswers(
          UserSelectedAnswers?.[SubjectData?.[QNo]?.questionId]?.split(",") || [
            "",
            "",
            "",
            "",
            "",
          ]
        );
        SetINQ("");
        SetUnits("");
      }
    }
  }, [QNo, SubjectData]);
  // Below is answer all questions in multiple
  const [OpenMAlert, CloseMAlert] = useState(false);
  // Above is answer all questions in multiple
  const UnitAnswerStore = (e, Sunits) => {
    const value = e?.target?.value || INQ;
    const STunits = Units || Sunits;
    if (value > 0) {
      if (SubjectData?.[QNo]?.answerType === "U" && STunits) {
        handleAnswerChange(
          SubjectData?.[QNo]?.questionId,
          SubjectData?.[QNo]?.answer,
          value,
          Sunits
        );
      } else {
        notify("Please select units", "warning");
      }
    }
  };

  const ExamHoldtime = () => {
    const FinialTime = SubDuration - AssessmentData?.assessmentTime;
    return `${String(FinialTime).padStart(2, "0")}`;
  };

  return (
    <div className={`Aswersheet-maindiv ${BackgroundBG()}`}>
      {!navigator.onLine ? (
        <InternetChecking />
      ) : GeTime < process.env.REACT_APP_ALERTFORASESSMENTDURATION ? (
        <p className="internerConnectionError">
          {process.env.REACT_APP_TIMELEFTFEESEC}
        </p>
      ) : (
        <p className="internerConnectionError"></p>
      )}
      <div className="dflex COlDiv">
        <div className="AButtonsDiv">
          <span className="BQuestion">Question</span>
          <div className="Buttons-Maindiv  dflex flexd-column alignitems">
            <div className="Display-Buttons">
              {SubjectData &&
                [...Array(SubjectData.length)].map((_, index) => (
                  <button
                    className={
                      UserSelectedAnswers[SubjectData[index].questionId] !==
                        undefined
                        ? "GreenButton"
                        : visitedQuestions.includes(
                          SubjectData[index].questionId
                        )
                          ? " OrangeButton"
                          : ""
                    }
                    key={index + 1}
                    onClick={() => {
                      if (navigator.onLine) {
                        seenQuestions(SubjectData[index].questionId);
                        setQNo(index);
                      }
                    }}
                  >
                    {index + 1}
                  </button>
                ))}
            </div>
            <hr style={{ width: "100%" }} />
            <div className="Answer-Details">
              {" "}
              <span>
                <WithTranslate name="Answersheet.Answered" />
              </span>{" "}
              <span>
                <WithTranslate name="Answersheet.Reviewed" />
              </span>{" "}
              <span>
                <WithTranslate name="Answersheet.Notseen" />
              </span>{" "}
            </div>
            <button
              className="ReviewSubmit Buttons Poppins"
              style={
                GeTime < ExamHoldtime() &&
                  Object.keys(UserSelectedAnswers).length > 0
                  ? {}
                  : {
                    cursor: "no-drop",
                    backgroundColor: "#E2F0EE",
                    color: "#1CA27A",
                  }
              }
              onClick={SubmitExam}
            >
              <WithTranslate name="Answersheet.Review&Submit" />
            </button>
          </div>
          <div className="Answersheet-Instructions">
            <p>
              {" "}
              <strong>
                <WithTranslate name="Answersheet.Instructions" />
              </strong>
            </p>

            <p className="text-danger">
              <WithTranslate name="Answersheet.Rule1" />
            </p>
            <p className="text-danger">
              <WithTranslate name="Answersheet.Rule2" />
            </p>
            <p>
              <WithTranslate name="Answersheet.Rule3" />
            </p>
          </div>
        </div>
        <div>
          <div className="Question-Answers">
            <div className="ExamTime-Details dflex alignitems">
              <span>
                <WithTranslate name="Answersheet.Subject" />{" "}
                {SubjectData && SubjectData[QNo]?.subjectName}
              </span>
              <span>
                <WithTranslate name="Answersheet.Duration" /> {SubDuration} min
              </span>
              <div className="Timeleft dflex alignitems">
                <span
                  style={
                    GeTime < process.env.REACT_APP_ALERTFORASESSMENTDURATION
                      ? { color: "red" }
                      : { color: "#0000E3" }
                  }
                >
                  <CiClock2 />
                </span>
                <div className="Runningtime dflex flexd-column">
                  <div
                    style={
                      GeTime < process.env.REACT_APP_ALERTFORASESSMENTDURATION
                        ? { color: "red" }
                        : {}
                    }
                  >
                    {PresentExam && (
                      <ExamTimeCal
                        contestCreationID={AssessmentData.contestCreationID}
                        UserId={items.userId}
                        duration={SubDuration}
                        Gtime={setGeTime}
                        SubName={PresentExam}
                        Timeup={saveAnswers}
                        Grade={items.grade}
                        // LastSubject={AssessmentData.subject3Name}
                        FinialSubject={
                          Subjects.length === CompleteSubjects.length
                        }
                        ConformModelCLose={SetCNFModel}
                        AssessmenType={AssessmentData.assessmentType}
                      />
                    )}
                  </div>
                  <span>Time Left</span>
                </div>
              </div>
            </div>

            <div className="Questions-Maindiv">
              <div className="Questions dflex flexd-column">
                {SubjectData && SubjectData[QNo].scenario && (
                  <span>
                    <b> Scenario:</b>{" "}
                    <ScenarioQuestionformat
                      scenario={SubjectData && SubjectData[QNo].scenario}
                    />
                  </span>
                )}

                <span className="dflex">
                  <b style={{ textWrap: "nowrap" }}>
                    {/* <WithTranslate name="Answersheet.Question" />  */}
                    Question {QNo + 1}:
                  </b>{" "}
                  <ScenarioQuestionformat
                    scenario={SubjectData && SubjectData[QNo].question}
                  />
                </span>
              </div>

              {SubjectData?.[QNo]?.questionType === "M" ? (
                ["A", "B", "C", "D"].map((option, index) => (
                  <>
                    {SubjectData[QNo]?.[`option${option}`] && (
                      <div className="Question-Options dflex">
                        <input
                          type="radio"
                          name={SubjectData && SubjectData[QNo]?.questionId}
                          value={option}
                          checked={
                            SubjectData &&
                            UserSelectedAnswers[
                            SubjectData[QNo]?.questionId
                            ] === option
                          }
                          onClick={(e) =>
                            handleAnswerChange(
                              e,
                              SubjectData[QNo]?.answer,
                              option
                            )
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleAnswerChange(
                                e,
                                SubjectData[QNo]?.answer,
                                option
                              );
                            }
                          }}
                        />
                        <span className="dflex MOptions">
                          {option})&nbsp;
                          <ScenarioQuestionformat
                            scenario={
                              SubjectData &&
                              SubjectData[QNo]?.[`option${option}`]
                            }
                          />
                        </span>
                      </div>
                    )}{" "}
                  </>
                ))
              ) : (
                <>
                  <div className="dflex gap-3 alignitems">
                    <b style={{ textWrap: "nowrap" }}>Answer : </b>
                    {/* {INQ} */}
                    <div className="dflex gap-2 alignitems">
                      {SubjectData?.[QNo]?.answerValType === "M" ? (
                        <>
                          {Array.from({
                            length:
                              SubjectData?.[QNo]?.answer?.split(",").length,
                          }).map((_, index) => (
                            <>
                              <input
                                type={SelecType()}
                                className="Search"
                                style={{ width: "5vw", padding: "1px 10px" }}
                                name={
                                  SubjectData && SubjectData?.[QNo]?.questionId
                                }
                                value={MAnswers[index]}
                                onChange={(e) => MAhandleChange(index, e)}
                                onBlur={(e) => {
                                  if (
                                    MAnswers.filter((str) => str !== "")
                                      .length ===
                                    SubjectData?.[QNo]?.answer?.split(",")
                                      .length
                                  ) {
                                    handleAnswerChange(
                                      e,
                                      SubjectData?.[QNo]?.answer,
                                      MAnswers
                                    );
                                  }
                                }}
                              />
                            </>
                          ))}
                        </>
                      ) : (
                        <>
                          {SubjectData?.[QNo]?.answerType !== "U" ? (
                            <textarea
                              placeholder="Enter Your Answer"
                              rows="3"
                              cols="50"
                              name={
                                SubjectData && SubjectData?.[QNo]?.questionId
                              }
                              value={INQ}
                              onChange={(e) => StoreINQAnswer(e)}
                              onfocus={() => SetEditQuestion(true)}
                              onBlur={(e) => {
                                // SetEditQuestion(false);
                                // AnswerStore(e)
                                // alert("on blur");
                                if (e?.target?.value.length > 0) {
                                  // if (SubjectData?.[QNo]?.answerType !== "U") {
                                  handleAnswerChange(
                                    e,
                                    SubjectData?.[QNo]?.answer,
                                    e.target.value
                                  );
                                }
                              }}
                            />
                          ) : (
                            <>
                              <input
                                type={SelecType()}
                                className="Search"
                                style={{ width: "5vw", padding: "1px 10px" }}
                                name={
                                  SubjectData && SubjectData?.[QNo]?.questionId
                                }
                                value={INQ}
                                onChange={(e) => StoreINQAnswer(e)}
                                onBlur={(e) => {
                                  UnitAnswerStore(e);
                                  // , SubjectData?.[QNo]?.answer, e.target.value
                                  // if (MAnswers.filter(str => str !== '').length === SubjectData?.[QNo]?.answer?.split(",").length) {
                                  //   handleAnswerChange(
                                  //     e,
                                  //     SubjectData?.[QNo]?.answer,
                                  //     MAnswers
                                  //   );
                                  // }
                                }}
                              />
                              {Units}
                              <UnitsDD
                                className="NCLDropdown w-100"
                                SubjectId="0"
                                LovId="72"
                                PID="0"
                                LID="0"
                                // labelname={
                                //   <div className="DropdownHeader mt-2">
                                //     Unit of Measure <span>*</span>
                                //   </div>
                                // }
                                // StoreValue={SetUnits}
                                Displayname="Select Units"
                                SOption={
                                  UserSelectedAnswers?.[
                                  SubjectData?.[QNo]?.questionId
                                  ]?.[1] || Units
                                }
                                onChange={(e) => {
                                  SetUnits(e);
                                  UnitAnswerStore(
                                    SubjectData?.[QNo]?.questionId,
                                    e
                                  );
                                }}
                                HideOption="O"
                              />
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="Change-Questions dflex alignitems">
                {QNo !== 0 ? (
                  <button
                    disabled={QNo === 0}
                    onClick={() => {
                      if (navigator.onLine) {
                        seenQuestions(SubjectData[QNo - 1].questionId);
                        setQNo(QNo - 1);
                      }
                    }}
                  >
                    <FaCaretLeft />
                    <WithTranslate name="Answersheet.PreviousQuestion" />
                  </button>
                ) : (
                  ""
                )}
                {SubjectData && QNo !== SubjectData.length - 1 ? (
                  <div className="dflex flexd-column">
                    <button
                      disabled={SubjectData && QNo === SubjectData.length - 1}
                      style={QNo !== 0 ? {} : { marginLeft: "28vw" }}
                      onClick={() => {
                        if (
                          (MAnswers.filter((str) => str !== "").length >= 1 &&
                            SubjectData?.[QNo]?.answerValType === "M" &&
                            SubjectData?.[QNo]?.answer?.split(",").length !==
                            MAnswers.filter((str) => str !== "").length) ||
                          (SubjectData?.[QNo]?.answerType === "U" &&
                            !Units &&
                            INQ)
                        ) {
                          CloseMAlert(!OpenMAlert);
                        } else {
                          if (navigator.onLine) {
                            seenQuestions(SubjectData[QNo + 1].questionId);
                            setQNo(QNo + 1);
                          }
                        }
                      }}
                    >
                      <WithTranslate name="Answersheet.NextQuestion" />{" "}
                      <FaCaretRight />
                    </button>
                  </div>
                ) : (
                  ""
                )}

                <button
                  className="ReviewSubmit Buttons"
                  onClick={SubmitExam}
                  style={{
                    ...(GeTime < ExamHoldtime() &&
                      Object.keys(UserSelectedAnswers).length > 0
                      ? {}
                      : {
                        cursor: "no-drop",
                        backgroundColor: "#E2F0EE",
                        color: "#1CA27A",
                      }),
                  }}
                >
                  {" "}
                  <WithTranslate name="Answersheet.Review&Submit" />{" "}
                </button>
              </div>

              <div
                className="BlinkingText text-danger mt-4 p-2"
                style={{
                  border: "2px solid red",
                  borderRadius: "10PX",
                  fontSize: "18px",
                }}
              >
                <b>
                  <MdOutlineSpeakerNotes />
                  <WithTranslate name="InstructionsPage.Note" />
                </b>{" "}
                <WithTranslate name="InstructionsPage.Note1" />
                {AssessmentData?.assessmentTime}{" "}
                <WithTranslate name="InstructionsPage.Note2" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <CopyRight />

      {OpenModel && (
        <div className="SubmitModel">
          <ReviewSubmit
            ModelCLose={CLoseModel}
            ConformModelCLose={SetCNFModel}
            TotalQuestions={SubjectData.length}
            changExam={saveAnswers}
            subjectname={SubjectData[QNo].subjectName}
            answered={Object.keys(UserSelectedAnswers).length}
            // LastSubject={AssessmentData.subject3Name}
            remaningtime={GeTime}
            Relatedtext={SetCNFsubmit}
          />
        </div>
      )}

      {CNFModel && (
        <div className="SubmitModel">
          <CNFSubmit
            ConformModelCLose={SetCNFModel}
            changExam={saveAnswers}
            subjectname={SubjectData[QNo]?.subjectName}
            NextSubject={Subjects[CompleteSubjects.length]}
            FinialSubject={Subjects.length === CompleteSubjects.length}
            //             FinialSubject = {((AssessmentData?.assessmentType === 3 && (items?.grade === 1 || items?.grade === 2)) ? lastSubject :
            // AssessmentData?.testType !== "single" ? subjectname.toLowerCase() === lastSubject.toLowerCase() : "True" )}
            TextRelated={CNFsubmit}
          />
        </div>
      )}

      {STModel && (
        <div className="SubmitModel">
          <div className="CNFSubmit-mainDiv dflex flexd-column alignitems">
            <span>
              {" "}
              {/* You have answered all {SubjectData?.length} questions. Since you
              still have time left you are requested to go back and check your
              answers to improve your score. */}
              <WithTranslate name="Answersheet.Timeleftpopup1" />{" "}
              <b>{SubjectData?.length}</b>{" "}
              <WithTranslate name="Answersheet.Timeleftpopup2" />
            </span>
            <button className="Buttons" onClick={() => SetSTModel(false)}>
              {" "}
              Close
            </button>
          </div>
        </div>
      )}

      {OpenMAlert && (
        <div className="Model-Open">
          <div className="Card">
            {" "}
            {SubjectData?.[QNo]?.answerType === "U"
              ? "Please select  units"
              : "PLease answer all the input fields"}
            <div className="dflex gap-3" style={{ justifyContent: "end" }}>
              <button
                className="Buttons"
                onClick={() => {
                  if (navigator.onLine) {
                    seenQuestions(SubjectData[QNo + 1].questionId);
                    setQNo(QNo + 1);
                    CloseMAlert(false);
                  }
                }}
              >
                ok
              </button>
              <button
                className="Buttons bg-danger"
                onClick={() => CloseMAlert(!OpenMAlert)}
              >
                Cancle
              </button>
            </div>
          </div>
        </div>
      )}

      {Load && <Loading />}
    </div>
  );
};
export default Ansewersheet;
